import DefaultLayout from '@/components/DefaultLayout'
import BreadCrum from '@/components/global/BreadCrum'
import GoodsComponentWithDiscountNew from '@/components/GoodsComponentWithDiscountNew'
import Chart from '@/components/productDetail/ProductReviews/components/Chart'
import googleStyles from '@/styles/productDetail/productReviews.module.scss'
import GoogleReviews from '@/components/productDetail/ProductReviews/GoogleReviews'
import featuredSectionApi from '@/service/modules/featuredSectionApi'
import styles from '@/styles/reviews.module.scss'
import { Button, Rate, Skeleton } from 'antd'
import getConfig from 'next/config'
import Image from 'next/image'
import { useEffect, useState } from 'react'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
import CSlogo from '@/svgs/CSlogo.svg'
import Head from 'next/head'
export default function CrazySalesReviews() {

  const [loading, setLoading] = useState(true)
  const [reviewSummary, setReviewSummary] = useState({ count: 0, item: {}, avgScore: 0 })


  const getReviews = (data: any) => {
    if (data) {
      setLoading(false)
      const { googleReview, googleReviewCount, googleScoreReview, reviewSummary } = data
      setReviewSummary(reviewSummary)
    } else {
      setLoading(false)
    }
  }

  const formatScore = (score: number) => {
    const decimal = score - Math.floor(score);
    return decimal > 0.4 ? Math.floor(score) + 0.5 : score;
  };

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals
          & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>
      <DefaultLayout>
        <div className={styles['crazySale-review']}>
          <div className={styles['crazySale-review-main']}>
            <div className={styles["bread-box"]}>
              <BreadCrum BreadList={[{
                name: "Crazy Sales Reviews",
                url: "/review",
                current: true
              }]}></BreadCrum>
            </div>

            <div className={styles['summary-of-comments']}>
              <div className={styles['crazySale-info']}>
                <CSlogo style={{ width: 100, height: 100 }} />
                <div className={styles['info']}>
                  <h2>crazysales.com.au</h2>
                  {
                    loading
                      ?
                      <Skeleton.Input active style={{ width: 380, margin: '8px 0' }} />
                      :
                      <div className={styles['info-review']}>
                        <div className={styles['point']}>{reviewSummary.avgScore}</div>
                        <div className={styles['rate']}>
                          <Rate disabled value={formatScore(reviewSummary.avgScore)} allowHalf />
                        </div>
                        <div className={styles['positive']}>{`${(reviewSummary.avgScore / 5 * 100).toFixed(0)}%`} positive</div>
                      </div>
                  }
                  <p>Ratings based on data collected by Google and/or its partners</p>
                </div>
              </div>

              {
                loading
                  ?
                  <Skeleton paragraph={{ rows: 3 }} active style={{ width: 400 }} />
                  :
                  <div className={styles['summary-data']}>
                    <div className={styles["chart-list"]}>
                      <Chart reviewSummary={reviewSummary.item} reviewCount={reviewSummary.count} />
                    </div>
                    <div className={styles['summary']}>
                      <div className={styles['reviewTotal']}>{reviewSummary.count}</div>
                      <Button type="primary" style={{ width: 90, padding: 0, color: '#fff', margin: '4px 0', pointerEvents: "none" }} >reviews</Button>
                      <span style={{ color: '#575656', fontSize: 14 }}>In Total</span>
                    </div>
                  </div>
              }
            </div>

            <div className={styles['ux-box']}>
              <div className={styles['ux-box-image']}>
                <Image
                  src={`${imageDomain}/crazysales-reviews-hands.jpg`}
                  alt='crazysale-ux'
                  width={260}
                  height={163}
                  layout="responsive"
                />
              </div>
              <div className={styles['ux-info']}>
                <h2>{`Crazy Sales Reviews gather our customers' experience on Crazy sales.`}</h2>
                <p>{`Read crazy sales reviews on Crazysales.com.au. Crazy Sales Review shows you straight happy customer online shopping experience. Hear what Google Customer Reviews have said about Crazy Sales .`}</p>
              </div>
            </div>

            <div className={`${styles['review-list']} ${googleStyles['product-reviews']}`}>
              <h2>{reviewSummary.count} reviews from <span >Google Customer Reviews</span></h2>
              <GoogleReviews productID={""} hideDetail={true} hideTopPage={true} callback={getReviews} />
              <div className={styles['see-more-reviews']}>
                <Button type="link" href="https://www.google.com/storepages?q=crazysales.com.au&c=HK&v=19" target="_blank" style={{ padding: 0 }}>See more reviews</Button>
              </div>
            </div>

            <div className={styles['hot-new-list']}>
              <h2>HOT & NEW</h2>
              <HotNewList />
              <div className={styles['view-more']}>
                <Button type="primary" href="/">View More</Button>
              </div>
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}


const HotNewList = () => {
  const [goodsList, setGoodsList] = useState<any>([])

  const getList = async () => {
    try {
      const res = await featuredSectionApi.getNewHotList()
      const pageList = res.data
      let list: any = []
      if (pageList && pageList.length) {
        list = pageList.map((v: any) => {
          const obj = {
            ...v,
            productName: v.name,
            imgUrl: v.filename ? v.filename : ""
          }
          return obj
        })
      }
      setGoodsList(list)
    } catch (error: any) {
      console.log(error.message);

    }
  }

  useEffect(() => {
    getList()
  }, [])

  return (
    <div className={styles['goods-list']}>
      {
        goodsList.map((item: any) => {
          return <div className={styles['goods-list-item']} key={item.id}>
            <GoodsComponentWithDiscountNew {...item} />
          </div>
        })
      }
    </div>
  )
}